import React from 'react';
import Page from './../../components/Page';
import { observer } from 'mobx-react-lite';
import UserChanges from './UserChanges';
import ErrorMessages from '../../components/ErrorMessages.js';

const UserChangesTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <UserChanges store={store} />
        </Page>
    );
};

export default observer(UserChangesTab);
